export const peripheryAddresses = {
  adaptiveCurveIRMFactory: "0x148B1DC3168C73907D9F00165Ceab62Fd81f3E9D",
  capRiskStewardFactory: "0x46a8a09dc96b35d14F556ba9462857d83002269a",
  edgeFactory: "0x3f7E741777A979BEB80C227949edde6814505475",
  edgeFactoryPerspective: "0x57E2e654d1576a02BeAaf3113C3faA9183c379eD",
  escrowedCollateralPerspective: "0xD775c4960c3A1B4A6A9962e37ecDe5c6b5fd56Fb",
  eulerEarnFactoryPerspective: "0x12241404ea27FA4BF7ECDAD2Cb13A99860d7d4Ac",
  eulerEarnGovernedPerspective: "0xeE3de4507cFAc8756634dC5272B4A6BB7f00C49E",
  eulerEarnPublicAllocator: "0x0161FE2CA6ED39b5D0811a94b87AC628677Ae020",
  eulerUngoverned0xPerspective: "0x068789293D461Be145D14BfC0e270941554CAC26",
  eulerUngovernedNzxPerspective: "0xfbB90dce4a2aCb5425b96B7886D621DE913c816D",
  evkFactoryPerspective: "0x03a931446F5A7e7ec1D850D8eaF95Ab68Ad9089C",
  externalVaultRegistry: "0xFB13aa1d7CFe1C85826f9D5e571589B13b785A6e",
  feeCollector: "0x0000000000000000000000000000000000000000",
  feeFlowController: "0xA1585dc7Cd4EF33f7a855fDE39771b37838B0bFE",
  feeFlowControllerUtil: "0x181042fcaC5926CDC89Cecbcf293Bb3b3ee5eC48",
  fixedCyclicalBinaryIRMFactory: "0xe962595391F481c4EB2cB8Adef7a064B1F76C36f",
  governedPerspective: "0xc7693ceEf74Bc7c8Af703c5519F24bB5e6642643",
  governorAccessControlEmergencyFactory:
    "0x27369477130C8bC49CeeAe8ACb9cE50a2a7De616",
  irmRegistry: "0xC66887f15038db0379bb9Feb020Feab0F93D8f0E",
  kinkIRMFactory: "0xE055ea126c7704fFCf3Bd8a8F46aC93A6965560E",
  kinkyIRMFactory: "0x1abB566e1cc1efd19594fF2dCF1219F71e06558A",
  oracleAdapterRegistry: "0x3942A72f87Db5Ad9C22d8826FDe15E23b81b1cBf",
  oracleRouterFactory: "0x22d51Db42A59862D4F8c135C4406AEf9854ABFF3",
  swapVerifier: "0x7b16DAaFa76CfeC8C08D7a68aF31949B37ebfdF5",
  swapper: "0x6eE488A00A2ef1E2764cD7245F8a77C40060A7C7",
  termsOfUseSigner: "0x8259735562F02356CcEf2577c60A63391d6F48e4",
} as const
